import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "mission-description__tooltip" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import StrategyBriefHubStepLayout from '@/brief-hub/common/ui/layout/StrategyBriefHubStepLayout.vue';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {computed, onMounted, ref, watch} from 'vue';
    import {StrategyMissionDescriptionBriefRequest} from '@/common/api/api-raw-types';
    import {useGlobalProperties} from '@malt/vue3-use';
    import StrategyTooltipsDescription from '@/brief-hub/strategy/deposit/mission/StrategyTooltipsDescription.vue';
    import StrategyTooltipsTitle from '@/brief-hub/strategy/deposit/mission/StrategyTooltipsTitle.vue';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';

    const TITLE_MIN_LENGTH = 10;
    const TITLE_MAX_LENGTH = 90;
    const DESCRIPTION_MAX_LENGTH = 10000;
    const DESCRIPTION_MIN_LENGTH = 200;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefMissionDescription',
  setup(__props) {

    const {$msg, $features} = useGlobalProperties();
    const briefStrategyStore = useBriefStrategyStore();
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const title = ref<string>(briefStrategyStore.briefStrategyMission.title || '');
    const description = ref<string>(briefStrategyStore.briefStrategyMission.description || '');
    const currentTooltipName = ref<'title' | 'description'>('title');
    const descriptionPlaceholder = computed<string>(() => {
        return $msg('customer.brief.exec.form.mission.project.description.placeholder');
    });

    const currentTooltipsComponent = computed<typeof StrategyTooltipsTitle | typeof StrategyTooltipsDescription | null>(() => {
        if (currentTooltipName.value === 'title') {
            return StrategyTooltipsTitle;
        }
        if (currentTooltipName.value === 'description') {
            return StrategyTooltipsDescription;
        }
        return null;
    });

    const invalidTitleMin = computed((): boolean => title.value.length > 0 && title.value.length < TITLE_MIN_LENGTH);

    const invalidTitleMax = computed((): boolean => title.value.length > 0 && title.value.length > TITLE_MAX_LENGTH);

    onMounted(() => {
        triggerBriefFunnelStepEnteredAmplitudeEvent('mission_description', 7);
    });

    function handleTitleFocus() {
        currentTooltipName.value = 'title';
    }
    function handleDescriptionChange(event: CustomEvent<{value: string}>) {
        const textarea = event.target as HTMLTextAreaElement;
        description.value = textarea.value;
    }
    function handleDescriptionFocus() {
        currentTooltipName.value = 'description';
    }

    const isFormValid = computed<boolean>(() => {
        return (
            description.value.length >= DESCRIPTION_MIN_LENGTH &&
            description.value.length <= DESCRIPTION_MAX_LENGTH &&
            title.value.length >= TITLE_MIN_LENGTH &&
            title.value.length <= TITLE_MAX_LENGTH
        );
    });

    watch(
        [title, description],
        () => {
            if (isFormValid.value) {
                const payload: StrategyMissionDescriptionBriefRequest = {
                    description: description.value,
                    title: title.value,
                };
                briefStrategyStore.updatePayload({
                    type: 'StrategyMissionDescriptionBriefRequest',
                    payload: payload,
                });
            } else {
                briefStrategyStore.resetPayload();
            }
        },
        {immediate: true},
    );

return (_ctx: any,_cache: any) => {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoyInput = _resolveComponent("VJoyInput")!
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_joy_textarea = _resolveComponent("joy-textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StrategyBriefHubStepLayout, { "has-sidebar": true }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.mission.title')), 1)
      ]),
      right: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(currentTooltipsComponent.value)))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch",
          "row-gap": "4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_VJoyLabel, {
                for: "mission-title",
                class: "step__title"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.mission.project.title.label')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_VJoyInput, {
                id: "mission-title",
                ref: "inputMissionTitle",
                modelValue: title.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                autofocus: "",
                "data-testid": "input-brief-mission-title",
                name: "mission-title",
                type: "text",
                autocomplete: "off",
                placeholder: _unref($msg)('customer.brief.exec.form.mission.project.title.placeholder'),
                min: TITLE_MIN_LENGTH,
                max: TITLE_MAX_LENGTH,
                required: ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (invalidTitleMin.value || invalidTitleMax.value)
                  ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                      key: 0,
                      class: "no-margin"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (invalidTitleMin.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_2, _toDisplayString(_unref($msg)('customer.brief.exec.form.input.number.error.min', TITLE_MIN_LENGTH)), 1))
                            : _createCommentVNode("", true),
                          (invalidTitleMax.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_3, _toDisplayString(_unref($msg)('customer.brief.exec.form.input.number.error.max', TITLE_MAX_LENGTH)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_VJoyLabel, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.mission.project.description.label')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_joy_textarea, {
            ref: "inputMissionDescription",
            "auto-grow": "",
            "data-testid": "textarea-brief-mission-description",
            minlength: DESCRIPTION_MIN_LENGTH,
            "minlength-label": _unref($msg)('general.min.count', DESCRIPTION_MIN_LENGTH),
            maxlength: DESCRIPTION_MAX_LENGTH,
            placeholder: descriptionPlaceholder.value,
            rows: "10",
            name: "textarea-brief",
            value: description.value,
            onValueChange: handleDescriptionChange,
            onJoyTextareaFocus: handleDescriptionFocus,
            onJoyTextareaBlur: handleTitleFocus
          }, null, 8, ["minlength-label", "placeholder", "value"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})